import type { ComponentSchema } from '../../../../../schema-types'
import { schema as base } from '../product/product-detail.schema'

/**
 * Urban Drip product page: the base fields plus a size-guide drawer (merchant rich text), the "Complete the
 * look" rail and the delivery areas table. All optional; empty values hide their piece.
 */
export const schema: ComponentSchema = {
  ...base,
  commonFields: [
    ...base.commonFields,
    { key: 'sizeGuideTitle', label: 'Size guide link and title', type: 'string', default: 'Size guide' },
    { key: 'sizeGuide', label: 'Size guide', type: 'rich-text', help: 'Measurements table or fit notes, opened from a link beside the size selector. Hidden while empty.' },
    { key: 'completeTheLookTitle', label: '"Complete the look" title', type: 'string', default: 'Complete the look', help: 'Other products from the same category, shown under the product.' },
    { key: 'showDeliveryAreas', label: 'Show delivery areas and charges', type: 'boolean', default: true },
  ],
}
